import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";
import { IoArrowBack, IoSearch } from "react-icons/io5";

const UserCoinDetails = () => {
    const { id } = useParams();
    const navigate = useNavigate();

    const [user, setUser] = useState(null);
    const [transactions, setTransactions] = useState([]);
    const [loading, setLoading] = useState(true);

    const [page, setPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);

    useEffect(() => {
        fetchUser();
        fetchTransactions(1);
    }, []);

    const fetchUser = async () => {
        try {
            const res = await axios.get(`/api/v1/admin/users/${id}`);
            setUser(res.data.data);
        } catch (e) {
            console.error("UserFetchErr:", e);
        }
    };

    const fetchTransactions = async (page) => {
        try {
            setLoading(true);
            const res = await axios.get(`/api/v1/app/coin-earnings/get-transactions/${id}`, {
                params: { page, limit: 10 }
            });

            if (res.data.status === "OK") {
                setTransactions(res.data.data.transactions);
                setTotalPages(res.data.data.pagination.totalPages);
                setPage(page);
            }
        } catch (e) {
            console.error("Tx Err:", e);
        } finally {
            setLoading(false);
        }
    };

    if (!user) {
        return (
            <div className="p-6 text-center text-[var(--yellow)]">
                Loading user...
            </div>
        );
    }

    return (
        <div className="p-6 bg-white min-h-screen">

            {/* Back Button */}
            <button
                onClick={() => navigate(-1)}
                className="text-[var(--yellow)] flex items-center gap-2 mb-4 hover:opacity-80"
            >
                <IoArrowBack className="text-2xl" />
                Back
            </button>

            {/* User Header */}
            <div className="bg-[var(--black)] border border-[var(--yellow)] p-6 rounded-xl shadow-lg mb-6">
                <div className="flex items-center gap-4">
                    <img
                        src={
                            user.profileImage &&
                            user.profileImage !== "default-profile.jpg"
                                ? user.profileImage
                                : "https://via.placeholder.com/100"
                        }
                        className="w-20 h-20 rounded-full border border-[var(--yellow)] object-cover"
                    />

                    <div>
                        <p className="text-[var(--yellow)] text-2xl font-bold">{user.fullName}</p>
                        <p className="text-[var(--yellow)] opacity-80">{user.phoneNumber}</p>
                    </div>
                </div>
            </div>

            <h2 className="text-[var(--yellow)] text-xl font-bold mb-3">Recent Transactions</h2>

            {/* Transaction List */}
            <div>
                {loading ? (
                    <div className="text-center text-[var(--yellow)] py-6">Loading...</div>
                ) : transactions.length === 0 ? (
                    <p className="text-center text-gray-400 py-6">No transactions available</p>
                ) : (
                    transactions.map((tx) => (
                        <div
                            key={tx._id}
                            className="border border-[var(--yellow)] rounded-xl p-4 mb-4 bg-[var(--black)]"
                        >
                            <p className="font-bold text-[var(--yellow)]">{tx.source}</p>
                            <p className="text-[var(--yellow)] text-sm">Coins: {tx.coins}</p>
                            <p className="text-[var(--yellow)] text-sm opacity-70">
                                {new Date(tx.createdAt).toLocaleString()}
                            </p>
                            {tx.description && (
                                <p className="text-[var(--yellow)] opacity-80 mt-1 text-sm">
                                    {tx.description}
                                </p>
                            )}
                        </div>
                    ))
                )}
            </div>

            {/* Pagination */}
            {totalPages > 1 && (
                <div className="mt-6 flex justify-center gap-3">
                    <button
                        disabled={page === 1}
                        onClick={() => fetchTransactions(page - 1)}
                        className="px-4 py-2 bg-[var(--yellow)] text-[var(--black)] rounded-lg disabled:opacity-40"
                    >
                        Prev
                    </button>

                    <span className="text-[var(--yellow)]">
                        {page} / {totalPages}
                    </span>

                    <button
                        disabled={page === totalPages}
                        onClick={() => fetchTransactions(page + 1)}
                        className="px-4 py-2 bg-[var(--yellow)] text-[var(--black)] rounded-lg disabled:opacity-40"
                    >
                        Next
                    </button>
                </div>
            )}
        </div>
    );
};

export default UserCoinDetails;
